import { Color } from '../Enum/Color';
import { Scopable } from '../Interface/Scopable';

const reduceScopesToColor = (scopes: Scopable[]): Color => {
    if (scopes.find(scope => scope.resultaat === Color.Red)) {
        return Color.Red;
    }

    if (scopes.find(scope => scope.resultaat === Color.Orange)) {
        return Color.Orange;
    }

    if (scopes.find(scope => scope.resultaat === Color.Blue)) {
        return Color.Blue;
    }

    return Color.Green;
};

export default reduceScopesToColor;
